import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/All";
import Header from "./containers/Header";

const renderApp = () => {
  let e = document.getElementById("indexReviewsWidget");
  if (e) {
    ReactDOM.render(<App {...e.dataset} />, e);
  }

  e = document.getElementsByClassName("headerWidget");
  [].forEach.call(e, element =>
    ReactDOM.render(<Header {...element.dataset} />, element)
  );
};

window.renderApp = renderApp;
renderApp();



// WEBPACK FOOTER //
// ./src/index.js